var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 60,
    viewBox: "0 0 65 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_6213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0724 9.00134H6.92757C5.31072 9.00134 4 10.3121 4 11.9289V44.9859C4 46.6028 5.31072 47.9135 6.92757 47.9135H50.0724C51.6893 47.9135 53 46.6028 53 44.9859V11.9289C53 10.3121 51.6893 9.00134 50.0724 9.00134Z",
    fill: "#096784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.918 21.4067H12.4779C11.6088 21.4067 10.9043 22.1112 10.9043 22.9803V27.4204C10.9043 28.2895 11.6088 28.994 12.4779 28.994H16.918C17.7871 28.994 18.4916 28.2895 18.4916 27.4204V22.9803C18.4916 22.1112 17.7871 21.4067 16.918 21.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7261 21.4067H26.286C25.4169 21.4067 24.7124 22.1112 24.7124 22.9803V27.4204C24.7124 28.2895 25.4169 28.994 26.286 28.994H30.7261C31.5951 28.994 32.2997 28.2895 32.2997 27.4204V22.9803C32.2997 22.1112 31.5951 21.4067 30.7261 21.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5225 21.4067H40.0823C39.2133 21.4067 38.5088 22.1112 38.5088 22.9803V27.4204C38.5088 28.2895 39.2133 28.994 40.0823 28.994H44.5225C45.3915 28.994 46.096 28.2895 46.096 27.4204V22.9803C46.096 22.1112 45.3915 21.4067 44.5225 21.4067Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.918 33.1046H12.4779C11.6088 33.1046 10.9043 33.8091 10.9043 34.6782V39.1183C10.9043 39.9874 11.6088 40.6919 12.4779 40.6919H16.918C17.7871 40.6919 18.4916 39.9874 18.4916 39.1183V34.6782C18.4916 33.8091 17.7871 33.1046 16.918 33.1046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7261 33.1046H26.286C25.4169 33.1046 24.7124 33.8091 24.7124 34.6782V39.1183C24.7124 39.9874 25.4169 40.6919 26.286 40.6919H30.7261C31.5951 40.6919 32.2997 39.9874 32.2997 39.1183V34.6782C32.2997 33.8091 31.5951 33.1046 30.7261 33.1046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5225 33.1046H40.0823C39.2133 33.1046 38.5088 33.8091 38.5088 34.6782V39.1183C38.5088 39.9874 39.2133 40.6919 40.0823 40.6919H44.5225C45.3915 40.6919 46.096 39.9874 46.096 39.1183V34.6782C46.096 33.8091 45.3915 33.1046 44.5225 33.1046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7098 4H14.6976C13.1145 4 11.8311 5.28341 11.8311 6.86657V12.5509C11.8311 14.1341 13.1145 15.4175 14.6976 15.4175H14.7098C16.293 15.4175 17.5764 14.1341 17.5764 12.5509V6.86657C17.5764 5.28341 16.293 4 14.7098 4Z",
    fill: "#FA3676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3143 4H42.3021C40.719 4 39.4355 5.28341 39.4355 6.86657V12.5509C39.4355 14.1341 40.719 15.4175 42.3021 15.4175H42.3143C43.8975 15.4175 45.1809 14.1341 45.1809 12.5509V6.86657C45.1809 5.28341 43.8975 4 42.3143 4Z",
    fill: "#FA3676"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_6213",
    x: 0,
    y: 0,
    width: 65,
    height: 59.9135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.227451 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_6213"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_6213",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.58608107348db1a116c25e3e9ee3b930.svg";
export { ForwardRef as ReactComponent };